import axios from "axios";
import * as React from "react";
import { useEffect, useState } from "react";
import i18n from "i18n";
import { WBSStore } from "modules/WBS/WBSStore";
import {
  Grid,
  FormControl,
  Button,
  CircularProgress,
  withStyles,
} from "@material-ui/core";
import ReactSelect from "common/components/ReactSelect";
import { ActivitySearchStore } from "modules/activitySearch/ActivitySearchStore";
import { TakeOffStore } from "modules/takeOff/TakeOffStore";

const styles = (theme) => ({
  input: {
    fontFamily: "Roboto",
    fontSize: "23px",
    fontWeight: 400,
    width: "610px",
    margin: "0 auto",
    display: "block",
    "& :focus": {
      backgroundColor: "transparent",
    },
  },
  button: {
    margin: "0px 19px",
  },
});

const UpdateCompositionsTabe1 = (props) => {
  const { classes, chengeWbsId } = props;
  let { rateLibraries } = ActivitySearchStore;

  const [listOptions, setListOptions] = useState<string[]>();
  const [categoria, setCategoria] = useState();
  const [loading, setLoading] = useState(false);

  const handleChange = (event) => {
    setCategoria(event);
  };

  const handleSave = async (event) => {
    setLoading(true);
    let index: any = categoria;
    if (index.value != undefined) {
      let item = rateLibraries[index.value];
      chengeWbsId(item.id);

      WBSStore.CompositionUsedToUpdate = item.id;
      WBSStore.compareEAPCompositionsWithRateLibrary(item.id).then(() => {
        setLoading(false);
        TakeOffStore.swipeTabComposition = 1;
      });
    }
  };

  const cancel = (event) => {
    WBSStore.replaceComposition = false;
    WBSStore.resetCompositionUpdateData();
  };

  useEffect(() => {
    let list = rateLibraries.map((m) => m.data.name);
    setListOptions(list);
  }, rateLibraries);

  return (
    <>
      {loading ? (
        <Grid
          item
          style={{
            position: "absolute",
            height: "100%",
            width: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            flexDirection: "column",
          }}
        >
          <CircularProgress style={{ color: "#9AAF00" }} />
          {i18n.updateCompositions.loading}...
        </Grid>
      ) : (
        <></>
      )}
      <Grid
        container
        direction="row"
        justify="center"
        alignItems="flex-start"
        style={{ position: "relative", height: "100%" }}
      >
        <Grid item style={{ position: "relative", height: "100%" }}>
          <div
            style={{
              fontFamily: "Roboto",
              fontSize: "12px",
              letterSpacing: "1.2px",
              color: "#000000DE",
              marginBottom: 22,
              marginTop: 50,
              textAlign: "center",
            }}
          >
            {i18n.noresults.ratelibrary.toUpperCase()}
          </div>
          <FormControl className={classes.input}>
            <ReactSelect
              listValues={listOptions}
              handleChange={handleChange}
              value={categoria}
              isMulti={false}
              placeholder={i18n.wbs.newRateLibraries}
            />
          </FormControl>
          <div
            style={{
              position: "absolute",
              width: "100%",
              bottom: "50px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={cancel}
            >
              {i18n.cancel}
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={handleSave}
              disabled={categoria == undefined}
            >
              {i18n.continue}
            </Button>
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default withStyles(styles)(UpdateCompositionsTabe1);



// WEBPACK FOOTER //
// ./src/modules/WBS/components/layouts/UpdateCompositionsTabe1.tsx